







































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { WorkerDetailsModule } from '@/store/modules/workerDetails';
import Availability from '@/models/Workers/Availability';
import WorkerAddressDetailsEdit from '@/components/Workers/WorkerAddressDetailsEdit.vue';
import GiganautVue from '@/components/Shared/GiganautVue';
import WorkerProfileDetailsEdit from '@/components/Workers/WorkerProfileDetailsEdit.vue';
import WorkerGeneralDetailsEdit from '@/components/Workers/WorkerGeneralDetailsEdit.vue';
import WorkerConvictionDetailsEdit from '@/components/Workers/WorkerConvictionDetailsEdit.vue';
import WorkerAvatarEdit from '@/components/Workers/WorkerAvatarEdit.vue';

import WorkType from '@/models/Shared/WorkType';
import { AppModule } from '@/store/modules/app';
import ListUtils from '@/lib/listUtils';

@Component({
  name: 'WorkerDetails',
  components: { WorkerProfileDetailsEdit, WorkerAvatarEdit, WorkerConvictionDetailsEdit, WorkerGeneralDetailsEdit, WorkerAddressDetailsEdit }
})
export default class extends GiganautVue {

	isAvailableMonAM: boolean;  
	isAvailableMonPM: boolean;  
	isAvailableTueAM: boolean;  
	isAvailableTuePM: boolean;  
	isAvailableWedAM: boolean;  
	isAvailableWedPM: boolean;  
	isAvailableThuAM: boolean;  
	isAvailableThuPM: boolean;  
	isAvailableFriAM: boolean;  
	isAvailableFriPM: boolean;  
	isAvailableSatAM: boolean;  
	isAvailableSatPM: boolean;  
	isAvailableSunAM: boolean;  
	isAvailableSunPM: boolean; 
	
	get IsAvailableMonAM() {
		return WorkerDetailsModule.currentWorker.availability.includes(Availability.MonAM)
	}
	set IsAvailableMonAM (isAvailable: boolean) {
		this.isAvailableMonAM = isAvailable
	}
	get IsAvailableTueAM() {
		return WorkerDetailsModule.currentWorker.availability.includes(Availability.TueAM)
	}
	set IsAvailableTueAM (isAvailable: boolean) {
		this.isAvailableTueAM = isAvailable
	}
	get IsAvailableWedAM() {
		return WorkerDetailsModule.currentWorker.availability.includes(Availability.WedAM)
	}
	set IsAvailableWedAM (isAvailable: boolean) {
		this.isAvailableWedAM = isAvailable
	}
	get IsAvailableThuAM() {
		return WorkerDetailsModule.currentWorker.availability.includes(Availability.ThuAM)
	}
	set IsAvailableThuAM (isAvailable: boolean) {
		this.isAvailableThuAM = isAvailable
	}
	get IsAvailableFriAM() {
		return WorkerDetailsModule.currentWorker.availability.includes(Availability.FriAM)
	}
	set IsAvailableFriAM (isAvailable: boolean) {
		this.isAvailableFriAM = isAvailable
	}
	get IsAvailableSatAM() {
		return WorkerDetailsModule.currentWorker.availability.includes(Availability.SatAM)
	}
	set IsAvailableSatAM (isAvailable: boolean) {
		this.isAvailableSatAM = isAvailable
	}
	get IsAvailableSunAM() {
		return WorkerDetailsModule.currentWorker.availability.includes(Availability.SunAM)
	}
	set IsAvailableSunAM (isAvailable: boolean) {
		this.isAvailableSunAM = isAvailable
	}
	get IsAvailableMonPM() {
		return WorkerDetailsModule.currentWorker.availability.includes(Availability.MonPM)
	}
	set IsAvailableMonPM (isAvailable: boolean) {
		this.isAvailableMonPM = isAvailable
	}
	get IsAvailableTuePM() {
		return WorkerDetailsModule.currentWorker.availability.includes(Availability.TuePM)
	}
	set IsAvailableTuePM (isAvailable: boolean) {
		this.isAvailableTuePM = isAvailable
	}
	get IsAvailableWedPM() {
		return WorkerDetailsModule.currentWorker.availability.includes(Availability.WedPM)
	}
	set IsAvailableWedPM (isAvailable: boolean) {
		this.isAvailableWedPM = isAvailable
	}
	get IsAvailableThuPM() {
		return WorkerDetailsModule.currentWorker.availability.includes(Availability.ThuPM)
	}
	set IsAvailableThuPM (isAvailable: boolean) {
		this.isAvailableThuPM = isAvailable
	}
	get IsAvailableFriPM() {
		return WorkerDetailsModule.currentWorker.availability.includes(Availability.FriPM)
	}
	set IsAvailableFriPM (isAvailable: boolean) {
		this.isAvailableFriPM = isAvailable
	}
	get IsAvailableSatPM() {
		return WorkerDetailsModule.currentWorker.availability.includes(Availability.SatPM)
	}
	set IsAvailableSatPM (isAvailable: boolean) {
		this.isAvailableSatPM = isAvailable
	}
	get IsAvailableSunPM() {
		return WorkerDetailsModule.currentWorker.availability.includes(Availability.SunPM)
	}
	set IsAvailableSunPM (isAvailable: boolean) {
		this.isAvailableSunPM = isAvailable
	}

	get isTemp() {
		return this.currentWorker.workTypes.includes(WorkType.Temp);
	}

	get isPerm() {
		return this.currentWorker.workTypes.includes(WorkType.Perm);
	}

	get currentWorker() {
		return WorkerDetailsModule.currentWorker;
	}

	titleLabel(v: number): string {
		const match = ListUtils.titles().find(item => item.value === v);
		return match ? match.name : '—';
	}

	get avatarUrl() {
        return AppModule.currentAgencyContext.storageSharedBaseUrl + "/avatars/3/" + this.currentWorker.id + "/" + this.currentWorker.avatar;
    }

	get avatarThumbnailUrl() {
        return AppModule.currentAgencyContext.storageSharedBaseUrl + "/avatars/3/" + this.currentWorker.id + "/resized-100/" + this.currentWorker.avatar;
    }

	availabilityClass(isAvailable: boolean){
		if (isAvailable) {
			return "available";
		} 
		else {
			return "unavailable";
		}
	}


}
